import * as PropTypes from 'prop-types';
import * as React from 'react';
import CartItem from './cart_item';
import PriceDisplay from '../../shared/price_display';
import UrlHelpers from '../../shared/url_helpers';
import CartStore from '../../cart/cart_store';
import CartActions from '../../cart/cart_actions';
import LPListingsActions from '../../lp_listings/lp_listings_actions';
import LPListingsStore from '../../lp_listings/lp_listings_store';
import hoverDropdown from '../hover_dropdown';

const MAXIMUM_VISIBLE_CART_ITEMS = 3;

class CartBadge extends React.Component {
  constructor(props) {
    super(props);

    this.onCartUpdated = this.onCartUpdated.bind(this);
    this.onLPListingsLoaded = this.onLPListingsLoaded.bind(this);

    this.state = {
      cart: null,
      lpListings: [],
    };
  }

  componentDidMount() {
    CartStore.listen(this.onCartUpdated);
    LPListingsStore.listen(this.onLPListingsLoaded);
    CartActions.loadCart();
  }

  componentWillUnmount() {
    CartStore.unlisten(this.onCartUpdated);
    LPListingsStore.unlisten(this.onLPListingsLoaded);
  }

  onCartUpdated() {
    const { cart } = CartStore.getState();
    this.setState({ cart }, () => {
      if (this.lpListingIds().length) {
        LPListingsActions.loadListings(this.lpListingIds());
      }
    });
  }

  onLPListingsLoaded() {
    const { lpListings } = LPListingsStore.getState();
    this.setState({ lpListings });
  }

  lpListingIds() {
    return this.state.cart.cartItems.reduce((ids, cartItem) => {
      if (cartItem.lp) { ids.push(cartItem.productId); }
      return ids;
    }, []);
  }

  get cartCount() {
    if (!this.state.cart) { return null; }

    return this.state.cart.count;
  }

  get countForDataTag() {
    if (this.cartCount > 0) { return this.cartCount; }
    return null;
  }

  get hasItems() {
    return this.state.cart && this.cartCount > 0;
  }

  get hasCredits() {
    return this.props.reverbCredits && this.props.reverbCredits.amount_cents > 0;
  }

  get bucksIcon() {
    return '<div class="reverb-bucks-icon"></div>';
  }

  merchandisingDataFor(item) {
    return this.state.lpListings.find(listing => listing.id === item.productId);
  }

  get visibleCartItems() {
    if (!this.state.cart) { return []; }

    return this.state.cart.cartItems.slice(0, MAXIMUM_VISIBLE_CART_ITEMS);
  }

  renderCartItems() {
    return this.visibleCartItems.map((item, i) => (
      <li
        key={i}
        data-cart-item-preview
      >
        <CartItem item={item} merchandisingData={this.merchandisingDataFor(item)} />
      </li>
    ));
  }


  renderCredits() {
    if (!this.hasCredits) { return null; }

    return (
      <li className="bdb-1 bd--offwhite">
        <div className="site-header__cart__credits-container">
          <span className="mr-space">
            {I18n.t('js.headerCart.credits')}
          </span>
          <div className="weight-bold color-green">
            <PriceDisplay
              price={this.props.reverbCredits}
              showCurrency
            />
          </div>
        </div>
      </li>
    );
  }

  renderDropdown() {
    if (!this.hasItems) { return null; }

    return (
      <div
        className="site-header__menu site-header__menu--cart"
        data-dropdown-active={this.props.isOpen}
      >
        <ul>
          {this.renderCredits()}
          {this.renderCartItems()}
          <li className="site-header__menu__footer">
            <a
              className="btn btn-primary btn-small wide"
              href={UrlHelpers.cartPath}
            >
              {I18n.t('js.headerCart.viewCart')}
            </a>
          </li>
        </ul>
      </div>
    );
  }

  render() {
    return (
      <div
        onMouseEnter={this.props.handleMouseEnter}
        onMouseLeave={this.props.handleMouseLeave}
      >
        <a
          className="site-header__nav__link site-header__nav__link--cart-icon"
          href={UrlHelpers.cartPath}
          aria-label={I18n.t('js.headerCart.badgeLabel')}
        >
          <div
            className="site-header__nav__link__icon"
            data-notification-count={this.countForDataTag}
          />
          <div className="site-header__nav__link__label">
            {I18n.t('js.headerCart.badgeLabel')}
          </div>
        </a>
        {this.renderDropdown()}
      </div>
    );
  }
}

CartBadge.propTypes = {
  reverbCredits: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  handleMouseEnter: PropTypes.func.isRequired,
  handleMouseLeave: PropTypes.func.isRequired,
};

export default hoverDropdown(CartBadge, 'CartBadge');



// WEBPACK FOOTER //
// ./javascripts/components/header/cart/cart_badge.jsx